import instance from "@/services/api";

export const providerNcaKeyStoreAPI = {
  /**
   * Получить все ключи
   */
  async readAll() {
    return await instance()
      .get("/provider_request/nca_key_store/read/")
      .then((res) => res?.data);
  },

  /**
   * Получить ключи для конкретного поставщика
   */
  async readByProvider(provider_id) {
    return await instance()
      .get("/provider_request/nca_key_store/by_provider/", {
        params: { provider_id },
      })
      .then((res) => res?.data);
  },

  /**
   * Загрузить ключ p12
   */
  async uploadKey(formData) {
    return await instance()
      .post("/provider_request/nca_key_store/upload/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => res?.data);
  },

  /**
   * Активировать ключ
   */
  async activate(provider_nca_key_store_id) {
    return await instance()
      .put(`/provider_request/nca_key_store/${provider_nca_key_store_id}/activate/`)
      .then((res) => res?.data);
  },

  /**
   * Деактивировать ключ
   */
  async deactivate(provider_nca_key_store_id) {
    return await instance()
      .put(`/provider_request/nca_key_store/${provider_nca_key_store_id}/deactivate/`)
      .then((res) => res?.data);
  },

  /**
   * Удалить ключ
   */
  async delete(provider_nca_key_store_id) {
    return await instance()
      .delete(`/provider_request/nca_key_store/${provider_nca_key_store_id}/delete/`)
      .then((res) => res?.data);
  },

  /**
   * Получить список поставщиков для выбора
   */
  async getProviders() {
    return await instance()
      .get("/provider_request/nca_key_store/providers/")
      .then((res) => res?.data);
  },
};
